var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var userModel = GenericModel.extend(
{

urlRoot : '/rest/api/user',
id : null,
name : "",
lastName : "",
userName : "",
email : ""
});

module.exports = userModel;